
















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'

@Component({
  components: {
    BaseButton
  }
})
export default class AdminContentItemActions extends Vue {
  @Prop({ required: true }) contentItemId!: number
  @Prop({ required: true }) contentItemShowPageRoute!: string
}
